import { isResultComment } from "@/react/components/HeaderV2/Search/SearchResult/searchResultHelpers";
import { SearchResultItem } from "../SearchResultItem";
import type { AdvancedSearchResult } from "../types";

interface Props {
  item: AdvancedSearchResult;
}
// this is just a compiled of all the different search result items, will be replaced when we have filters
export const SearchResult = ({ item }: Props) => {
  const { type } = item || {};

  const componentsMap: any = {
    post: SearchResultItem.Post,
    community_member: SearchResultItem.Member,
    comment: isResultComment(item) && SearchResultItem.Comment,
    lesson: SearchResultItem.Lesson,
    event: SearchResultItem.Event,
    image: SearchResultItem.ImagePost,
    messages: SearchResultItem.Messages,
  };

  const Component = componentsMap[type];

  if (!Component) {
    return null;
  }

  return <Component item={item} />;
};
